var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22249(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22249",
    "data-name": "Group 22249",
    transform: "translate(-190 -1202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22248",
    "data-name": "Group 22248",
    transform: "translate(-105 -1624.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(206.189 1220.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27655",
    "data-name": "Path 27655",
    d: "M45.128,39.97H8.495A5.5,5.5,0,0,1,3,34.475V30.812A1.832,1.832,0,0,1,4.832,28.98a5.495,5.495,0,1,0,0-10.99A1.832,1.832,0,0,1,3,16.158V12.495A5.5,5.5,0,0,1,8.495,7H45.128a5.5,5.5,0,0,1,5.495,5.495v3.663a1.832,1.832,0,0,1-1.832,1.832,5.495,5.495,0,0,0,0,10.99,1.832,1.832,0,0,1,1.832,1.832v3.663a5.5,5.5,0,0,1-5.495,5.495ZM6.663,32.46v2.015a1.832,1.832,0,0,0,1.832,1.832H45.128a1.832,1.832,0,0,0,1.832-1.832V32.46a9.158,9.158,0,0,1,0-17.95V12.495a1.832,1.832,0,0,0-1.832-1.832H8.495a1.832,1.832,0,0,0-1.832,1.832V14.51a9.158,9.158,0,0,1,0,17.95Z",
    transform: "translate(0 0)",
    fill: "#6d4eec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27656",
    "data-name": "Path 27656",
    d: "M13.832,12.495A1.832,1.832,0,0,1,12,10.663V8.832a1.832,1.832,0,0,1,3.663,0v1.832A1.832,1.832,0,0,1,13.832,12.495Z",
    transform: "translate(7.485 0)",
    fill: "#6d4eec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27657",
    "data-name": "Path 27657",
    d: "M13.832,27.495A1.832,1.832,0,0,1,12,25.663V23.832a1.832,1.832,0,1,1,3.663,0v1.832A1.832,1.832,0,0,1,13.832,27.495Z",
    transform: "translate(7.485 12.475)",
    fill: "#6d4eec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27658",
    "data-name": "Path 27658",
    d: "M13.827,15.663a1.832,1.832,0,1,1,1.3-.531,1.923,1.923,0,0,1-1.3.531Z",
    transform: "translate(7.49 4.158)",
    fill: "#6d4eec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27659",
    "data-name": "Path 27659",
    d: "M13.827,18.663a2,2,0,1,1,.7-.147A1.832,1.832,0,0,1,13.827,18.663Z",
    transform: "translate(7.49 6.653)",
    fill: "#6d4eec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27660",
    "data-name": "Path 27660",
    d: "M13.827,21.663a1.832,1.832,0,1,1,1.3-.531,1.923,1.923,0,0,1-1.3.531Z",
    transform: "translate(7.49 9.148)",
    fill: "#6d4eec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22249);
export default __webpack_public_path__ + "static/media/Group 22249.76188bfdf202bc948297bbe7c8b1fb76.svg";
export { ForwardRef as ReactComponent };